import "./page-header.scss";
import classNames from "classnames";
import React from "react";
import { Link } from "gatsby";
import { SectionDivider } from "../section-divider/section-divider";
import { PrismicImage, PrismicRichText } from "../../utils/queries/types";
// import RichTextRender from '../../utils/rich-text';

if (typeof window !== "undefined") {
  // eslint-disable-next-line global-require
  require("smooth-scroll")('a[href*="#"]');
}

export const PageHeaderCustom: React.FC<{
  image?: PrismicImage | React.ReactNode;
  hasSubnav?: boolean;
}> = ({ image, children, hasSubnav = false }) => {
  const wrapperClasses = classNames("page-header avenir bold", {
    "has-subnav": hasSubnav,
  });

  let imageContent = null;
  if (image) {
    if (image.hasOwnProperty("url")) {
      // image is PrismicImage;
      imageContent = <img src={image.url} alt={image.alt} />;
    } else {
      imageContent = image;
    }
  }

  return (
    <div className={wrapperClasses}>
      <div className="container">
        <div className="row flex justify-center">
          <div className="col-12 col-md-10">
            <div className="row">
              <div className="block lg:hidden col-12 mb-5">{imageContent}</div>
              <div className="col-12 col-md-7">{children}</div>
              <div className="hidden lg:block col-5">{imageContent}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const PageHeaderCustomV2: React.FC<{
  image?: PrismicImage | React.ReactNode;
  hasSubnav?: boolean;
}> = ({ image, children, hasSubnav = false }) => {
  const wrapperClasses = classNames("page-header-v2 avenir bold", {
    "has-subnav": hasSubnav,
  });

  let imageContent = null;
  if (image) {
    if (image.hasOwnProperty("url")) {
      // image is PrismicImage;
      imageContent = <img src={image.url} alt={image.alt} />;
    } else {
      imageContent = image;
    }
  }

  return (
    <div className={wrapperClasses}>
      <div className="container">
        <div className="row flex justify-center">
          <div className="col-12 col-lg-10">
            <div className="row">
              <div className="block lg:hidden col-12 mb-5">{imageContent}</div>
              <div className="col-12 col-md-7">{children}</div>
              <div className="hidden lg:block col-5">{imageContent}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const PageHeaderCustomV2Grey: React.FC<{
  image?: PrismicImage | React.ReactNode;
  hasSubnav?: boolean;
}> = ({ children, hasSubnav = false }) => {
  const wrapperClasses = classNames(
    "px-4 page-header-v2 page-header-v2--grey avenir bold",
    {
      "has-subnav": hasSubnav,
    }
  );

  return (
    <div className={wrapperClasses}>
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-10 offset-md-1 pl-0">{children}</div>
        </div>
      </div>
    </div>
  );
};

export const PageHeaderCustomV2WhiteWide: React.FC<{
  image?: PrismicImage | React.ReactNode;
  hasSubnav?: boolean;
}> = ({ image, children, hasSubnav = false }) => {
  const wrapperClasses = classNames(
    "page-header-v2 page-header-v2--white avenir bold",
    {
      "has-subnav": hasSubnav,
    }
  );

  let imageContent = null;
  if (image) {
    if (image.hasOwnProperty("url")) {
      // image is PrismicImage;
      imageContent = <img src={image.url} alt={image.alt} />;
    } else {
      imageContent = image;
    }
  }

  return (
    <div className={wrapperClasses}>
      <div className="container">
        <div className="row flex justify-center">
          <div className="col-12 col-lg-10">
            <div className="row">
              <div className="block lg:hidden col-12 mb-5">{imageContent}</div>
              <div className="col-12 col-md-7">{children}</div>
              <div className="hidden lg:block col-5">{imageContent}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

type PageHeaderParams = {
  image?: PrismicImage | React.ReactNode;
  header: string;
  subheader: string | PrismicRichText;
  hasSubnav?: boolean;
  hasSectionDivider?: boolean;
  withSiteName?: boolean;
  preHeader?: string;
  component?: React.FC;
};
export const PageHeaderStandard = ({
  image,
  hasSectionDivider = true,
  header,
  subheader,
  hasSubnav,
  withSiteName = false,
  preHeader,
  component,
}: PageHeaderParams) => {
  //const shRendered = '';
  //const bottomRendered = (typeof subheader === 'string') ? <p className='avenir'>{shRendered}</p> : '<p>Looking for digital strategies, website and application development services, Developer Portals or any other digital solution? amazee.io partners can help.</p><p><a href="#agency-partners-anchor">Become a Partner</a> <a href="#tech-partners-anchor">Technology Partners</a></p>';

  preHeader = preHeader || "amazee.io";
  const siteHeaderRendered = withSiteName ? (
    <div className="site-name">{preHeader}</div>
  ) : null;

  const Component: typeof PageHeaderCustom = component || PageHeaderCustom;

  /* If header is the only child with already an h1 then dont wrap it with an h1 tag */
  const wrapHeader =
    header &&
    header.props &&
    header.props.children &&
    header.props.children.length === 1 &&
    header.props.children[0].type === "h1";

  return (
    <Component hasSubnav={hasSubnav} image={image}>
      <div className="top">
        {siteHeaderRendered}
        {!wrapHeader ? <h1 className="avenir">{header}</h1> : header}
      </div>
      {hasSectionDivider ? <SectionDivider /> : <div style={{ height: 32 }} />}
      <div className="bottom">
        <p>
          Looking for digital strategies, website and application development
          services, Developer Portals or any other digital solution? amazee.io
          partners can help.
        </p>
        <p>
          <Link to="/our-partners#agency-partners-anchor">Agency Partners</Link>
          <Link to="/our-partners#tech-partners-anchor">
            Technology Partners
          </Link>
        </p>
      </div>
    </Component>
  );
};
